import { apiPost } from "./apiClient";

// Same regex was hand-duplicated in ChatPanelGallery.js and MessageParts.js.
export function parseContentDispositionFilename(contentDisposition) {
  const match = (contentDisposition || "").match(/filename="?([^";\n]+)"?/i);
  return match?.[1] || null;
}

// Reused by 7 files (chat gallery/bubble downloads, part-photo/proof
// re-upload flows in WorkflowTaskDrawer/CustomerEditDrawer/EditDraftDrawer,
// AI image analysis) to pull a WATI-hosted media file as a blob. Callers
// still resolve their own final display filename (they each have different
// fallback context — item.fileName, docInfo, a generated name) — this only
// centralizes the fetch and the content-disposition parse.
export function downloadWatiMediaBlob(rawUrl) {
  return apiPost(
    "/wati_messages/download_wati_media_file",
    { file_name: rawUrl },
    { responseType: "blob" }
  ).then(res => ({
    blob: res.data,
    fileName: parseContentDispositionFilename(res.headers?.["content-disposition"]),
  }));
}

// Resolves a raw WATI media path to a signed, browser-loadable URL.
// Callers (MessageParts._resolveMediaUrl) own their own expiry-aware cache
// on top of this — that TTL logic is UI-specific, not part of the fetch.
export function resolveMediaUrl(rawUrl) {
  return apiPost("/wati_messages/parse_media_file_url", { file_name: rawUrl })
    .then(res => (res.data?.success && res.data?.data) ? res.data.data : null);
}

export function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

// Uploads a File/Blob to the permanent image store. Callers build the
// File/Blob themselves (naming/extension varies per flow) — this just owns
// the FormData shape and the endpoint.
export function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  return apiPost("/whatsapp/image_upload", fd).then(res => res.data);
}
